import { Typography, UniversalImage } from '@monoimin/atoms';
import { Locales, Person } from '@monoimin/sb-types';
import { GravityForm } from '@monoimin/forms/gravity-form';
import { FormConfig } from '@monoimin/forms/gravity-form/types';

type FormWithExpertProps = {
  formConfig: FormConfig;
  locale: Locales;
  title: string;
  description: string;
  expert: Person;
};

export const FormWithExpert = ({
  formConfig,
  locale,
  title,
  description,
  expert,
}: FormWithExpertProps) => {
  return (
    <div className='w-fit h-full bg-blueGrey flex max-h-[95vh]'>
      <div className='flex flex-col overflow-y-auto max-w-xl xl:max-w-none p-5 xl:pl-10 xl:py-6 xl:w-1/2 xl:pr-0'>
        <Typography as='h2' className='h2 whitespace-nowrap'>
          {title}
        </Typography>
        <Typography className='body md:w-10/12 mb-3'>{description}</Typography>
        <GravityForm
          classNames={{
            container: 'w-full enquiry-form px-0',
          }}
          buttonPosition='left'
          locale={locale}
          formConfig={formConfig}
        />
      </div>
      <div className='hidden xl:flex xl:w-1/2 relative justify-start items-end'>
        <div className='flex flex-col absolute top-12 right-8 max-w-[200px]'>
          <Typography className='body font-bold w-fit'>
            {expert.name}
          </Typography>
          <Typography className='caption w-fit'>
            {expert.description}
          </Typography>
        </div>
        {expert.largeImage && (
          <UniversalImage
            pattern='dimensions'
            quality={100}
            priority
            width={388}
            height={586}
            alt={expert.name}
            src={expert.largeImage}
            className='object-contain'
          />
        )}
      </div>
    </div>
  );
};
